const menu = () => {

  const pageBody = document.body;
  const header = document.querySelector('.main-menu__navigation');
  const burgerMenu = document.querySelector('.main-menu__burger');
  const burgerCloseBtn = document.querySelector('.main-menu__close-btn');

  return {
    toggleMenu: () => {
      if (burgerMenu) {
        burgerMenu.addEventListener('click', () => {
          if (!header.classList.contains('open')) {
            pageBody.classList.add('open');
            header.classList.add('open');
          }
        });
        burgerCloseBtn.addEventListener('click', () => {
          if (header.classList.contains('open')) {
            pageBody.classList.remove('open');
            header.classList.remove('open');
          }
        });
        window.addEventListener('resize', () => {
          if (header.classList.contains('open')) {
            pageBody.classList.remove('open');
            header.classList.remove('open');
          }
        });
      }
    },
  };
};
export default menu;
